module.exports = __webpack_public_path__ + "static/media/wonky1.5ce67b20.jpg";